/**
 * Miradi Share UX Services
 * Miradi Share UX Services end-point (for internal use only)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { MiradiSubscription } from './miradiSubscription';


/**
 * Miradi Share user info (for those with projects)
 */
import { ValidateUtils } from 'app/shared/utils';

export class UserInfo { 
    /**
     * Unique identifier
     */
    readonly identifier?: string;
    /**
     * First name
     */
    readonly firstName?: string;
    /**
     * Last name
     */
    readonly lastName?: string;
    /**
     * Organization identifier
     */
    readonly organizationIdentifier?: string;
    /**
     * Organization name
     */
    readonly organizationName?: string;
    /**
     * Email address
     */
    readonly email?: string;
    /**
     * Username
     */
    readonly username?: string;
    /**
     * Timezone
     */
    readonly timezone?: string;
    /**
     * Date user account created
     */
    joinedDate?: string | null;
    /**
     * Date of last login for user
     */
    readonly lastLoginDate?: string;
    /**
     * Timestamp when user completed account setup
     */
    readonly accountSetupCompletedDatetime?: string | null;
    miradiSubscription?: MiradiSubscription;
    /**
     * Flag indicator whether user account has API access enabled
     */
    readonly apiAccessEnabled?: boolean;
    /**
     * Flag indicating whether User is beta tester
     */
    readonly isBetaTester?: boolean;
    /**
     * Comma-delimited list of programs that user is member of
     */
    readonly programs?: string;
    /**
     * Total project count (where team member)
     */
    readonly totalProjectCount?: number;
    /**
     * Program project count (where team member)
     */
    readonly programProjectCount?: number;
    /**
     * Total standalone project count (where team member)
     */
    readonly standaloneProjectCount?: number;
    /**
     * Total standalone project count (where project owner)
     */
    readonly standaloneProjectOwnerCount?: number;
    /**
     * List of associated subscriptions, directly or inherited by program / project membership
     */
    readonly associatedSubscriptions?: string;
    /**
     * Whether user has active subscription coverage from any source
     */
    readonly hasActiveSubscriptionCoverage?: boolean;
    /**
     * Whether user has edit capabilities anywhere (program or project level)
     */
    readonly hasEditCapabilities?: boolean;
    /**
     * Whether user should be nudged to get a subscription (has edit capabilities but no subscription)
     */
    readonly shouldNudgeForSubscription?: boolean;

    constructor(item?: Partial<UserInfo>) {
        
        Object.assign(this, item);
    }

    static getValidationObject(): any {
        return {
            identifier: {
                type: 'uuid',
                
                
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.identifier : itemOrValue;

                    if (itemOrValue?.identifier != null) {
                        if (itemOrValue.identifier === '') {
                            itemOrValue.identifier = undefined;
                        } else if (['int32', 'int64'].indexOf('uuid') >= 0) {
                            itemOrValue.identifier = parseInt(itemOrValue.identifier.toString(), 10);
                        } else if (['float'].indexOf('uuid') >= 0) {
                            itemOrValue.identifier = parseFloat(itemOrValue.identifier.toString());
                        }
                    }
                    result = result && ValidateUtils.isValidType(value, 'uuid');
                    if (['uuid'].indexOf('uuid') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, null, );
                    }

                    return result;
                }
            },
            firstName: {
                
                
                
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.firstName : itemOrValue;

                    if (['uuid'].indexOf('') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, null, );
                    }

                    return result;
                }
            },
            lastName: {
                
                
                
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.lastName : itemOrValue;

                    if (['uuid'].indexOf('') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, null, );
                    }

                    return result;
                }
            },
            organizationIdentifier: {
                type: 'uuid',
                
                
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.organizationIdentifier : itemOrValue;

                    if (itemOrValue?.organizationIdentifier != null) {
                        if (itemOrValue.organizationIdentifier === '') {
                            itemOrValue.organizationIdentifier = undefined;
                        } else if (['int32', 'int64'].indexOf('uuid') >= 0) {
                            itemOrValue.organizationIdentifier = parseInt(itemOrValue.organizationIdentifier.toString(), 10);
                        } else if (['float'].indexOf('uuid') >= 0) {
                            itemOrValue.organizationIdentifier = parseFloat(itemOrValue.organizationIdentifier.toString());
                        }
                    }
                    result = result && ValidateUtils.isValidType(value, 'uuid');
                    if (['uuid'].indexOf('uuid') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, null, );
                    }

                    return result;
                }
            },
            organizationName: {
                
                
                
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.organizationName : itemOrValue;

                    if (['uuid'].indexOf('') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, null, );
                    }

                    return result;
                }
            },
            email: {
                type: 'email',
                
                
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.email : itemOrValue;

                    if (itemOrValue?.email != null) {
                        if (itemOrValue.email === '') {
                            itemOrValue.email = undefined;
                        } else if (['int32', 'int64'].indexOf('email') >= 0) {
                            itemOrValue.email = parseInt(itemOrValue.email.toString(), 10);
                        } else if (['float'].indexOf('email') >= 0) {
                            itemOrValue.email = parseFloat(itemOrValue.email.toString());
                        }
                    }
                    result = result && ValidateUtils.isValidType(value, 'email');
                    if (['uuid'].indexOf('email') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, null, );
                    }

                    return result;
                }
            },
            username: {
                
                
                
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.username : itemOrValue;

                    if (['uuid'].indexOf('') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, null, );
                    }

                    return result;
                }
            },
            timezone: {
                
                
                
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.timezone : itemOrValue;

                    if (['uuid'].indexOf('') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, null, );
                    }

                    return result;
                }
            },
            joinedDate: {
                type: 'date',
                
                
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.joinedDate : itemOrValue;

                    if (itemOrValue?.joinedDate != null) {
                        if (itemOrValue.joinedDate === '') {
                            itemOrValue.joinedDate = undefined;
                        } else if (['int32', 'int64'].indexOf('date') >= 0) {
                            itemOrValue.joinedDate = parseInt(itemOrValue.joinedDate.toString(), 10);
                        } else if (['float'].indexOf('date') >= 0) {
                            itemOrValue.joinedDate = parseFloat(itemOrValue.joinedDate.toString());
                        }
                    }
                    result = result && ValidateUtils.isValidType(value, 'date');
                    if (['uuid'].indexOf('date') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, null, );
                    }

                    return result;
                }
            },
            lastLoginDate: {
                type: 'date-time',
                
                
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.lastLoginDate : itemOrValue;

                    if (itemOrValue?.lastLoginDate != null) {
                        if (itemOrValue.lastLoginDate === '') {
                            itemOrValue.lastLoginDate = undefined;
                        } else if (['int32', 'int64'].indexOf('date-time') >= 0) {
                            itemOrValue.lastLoginDate = parseInt(itemOrValue.lastLoginDate.toString(), 10);
                        } else if (['float'].indexOf('date-time') >= 0) {
                            itemOrValue.lastLoginDate = parseFloat(itemOrValue.lastLoginDate.toString());
                        }
                    }
                    result = result && ValidateUtils.isValidType(value, 'date-time');
                    if (['uuid'].indexOf('date-time') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, null, );
                    }

                    return result;
                }
            },
            accountSetupCompletedDatetime: {
                type: 'date-time',
                
                
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.accountSetupCompletedDatetime : itemOrValue;

                    if (itemOrValue?.accountSetupCompletedDatetime != null) {
                        if (itemOrValue.accountSetupCompletedDatetime === '') {
                            itemOrValue.accountSetupCompletedDatetime = undefined;
                        } else if (['int32', 'int64'].indexOf('date-time') >= 0) {
                            itemOrValue.accountSetupCompletedDatetime = parseInt(itemOrValue.accountSetupCompletedDatetime.toString(), 10);
                        } else if (['float'].indexOf('date-time') >= 0) {
                            itemOrValue.accountSetupCompletedDatetime = parseFloat(itemOrValue.accountSetupCompletedDatetime.toString());
                        }
                    }
                    result = result && ValidateUtils.isValidType(value, 'date-time');
                    if (['uuid'].indexOf('date-time') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, null, );
                    }

                    return result;
                }
            },
            miradiSubscription: {
                
                
                
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.miradiSubscription : itemOrValue;

                    if (['uuid'].indexOf('') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, null, );
                    }

                    return result;
                }
            },
            apiAccessEnabled: {
                
                
                
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.apiAccessEnabled : itemOrValue;

                    if (['uuid'].indexOf('') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, null, );
                    }

                    return result;
                }
            },
            isBetaTester: {
                
                
                
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.isBetaTester : itemOrValue;

                    if (['uuid'].indexOf('') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, null, );
                    }

                    return result;
                }
            },
            programs: {
                
                
                
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.programs : itemOrValue;

                    if (['uuid'].indexOf('') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, null, );
                    }

                    return result;
                }
            },
            totalProjectCount: {
                
                
                
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.totalProjectCount : itemOrValue;

                    if (['uuid'].indexOf('') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, null, );
                    }

                    return result;
                }
            },
            programProjectCount: {
                
                
                
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.programProjectCount : itemOrValue;

                    if (['uuid'].indexOf('') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, null, );
                    }

                    return result;
                }
            },
            standaloneProjectCount: {
                
                
                
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.standaloneProjectCount : itemOrValue;

                    if (['uuid'].indexOf('') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, null, );
                    }

                    return result;
                }
            },
            standaloneProjectOwnerCount: {
                
                
                
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.standaloneProjectOwnerCount : itemOrValue;

                    if (['uuid'].indexOf('') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, null, );
                    }

                    return result;
                }
            },
            associatedSubscriptions: {
                
                
                
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.associatedSubscriptions : itemOrValue;

                    if (['uuid'].indexOf('') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, null, );
                    }

                    return result;
                }
            },
            hasActiveSubscriptionCoverage: {
                
                
                
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.hasActiveSubscriptionCoverage : itemOrValue;

                    if (['uuid'].indexOf('') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, null, );
                    }

                    return result;
                }
            },
            hasEditCapabilities: {
                
                
                
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.hasEditCapabilities : itemOrValue;

                    if (['uuid'].indexOf('') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, null, );
                    }

                    return result;
                }
            },
            shouldNudgeForSubscription: {
                
                
                
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.shouldNudgeForSubscription : itemOrValue;

                    if (['uuid'].indexOf('') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, null, );
                    }

                    return result;
                }
            },
            isValid: UserInfo.isValid,
        };
    }

    static isValid(obj: UserInfo): boolean {
        if (!!obj) {
            const item = obj as any; // just to make things easier in this generated code...
            const validationObject = UserInfo.getValidationObject();
            let result = !item.$validationMessage;
            result = result && validationObject.identifier.isValid(item);
            result = result && validationObject.firstName.isValid(item);
            result = result && validationObject.lastName.isValid(item);
            result = result && validationObject.organizationIdentifier.isValid(item);
            result = result && validationObject.organizationName.isValid(item);
            result = result && validationObject.email.isValid(item);
            result = result && validationObject.username.isValid(item);
            result = result && validationObject.timezone.isValid(item);
            result = result && validationObject.joinedDate.isValid(item);
            result = result && validationObject.lastLoginDate.isValid(item);
            result = result && validationObject.accountSetupCompletedDatetime.isValid(item);
            result = result && validationObject.miradiSubscription.isValid(item);
            result = result && validationObject.apiAccessEnabled.isValid(item);
            result = result && validationObject.isBetaTester.isValid(item);
            result = result && validationObject.programs.isValid(item);
            result = result && validationObject.totalProjectCount.isValid(item);
            result = result && validationObject.programProjectCount.isValid(item);
            result = result && validationObject.standaloneProjectCount.isValid(item);
            result = result && validationObject.standaloneProjectOwnerCount.isValid(item);
            result = result && validationObject.associatedSubscriptions.isValid(item);
            result = result && validationObject.hasActiveSubscriptionCoverage.isValid(item);
            result = result && validationObject.hasEditCapabilities.isValid(item);
            result = result && validationObject.shouldNudgeForSubscription.isValid(item);
            return result;
        } else {
            return false
        }
    }
}

